import React from "react";

/**
 * Visually hidden until focused, then reveals top-left. Renders as a plain <a>
 * pointing to the main content landmark of each layout.
 */
export function SkipToContent({ targetId = "main-content" }) {
  return (
    <a
      href={`#${targetId}`}
      className="skip-to-content"
      data-testid="skip-to-content"
    >
      Skip to content
    </a>
  );
}

export default SkipToContent;
